import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { DeleteEmployeePayload } from "../../payload/DeleteEmployee/DeleteEmployeePayload";

const deleteEmployeeFetch = (state: EmployeesState, action: PayloadAction<DeleteEmployeePayload>) => {
    state.isLoading = true;
}

export default deleteEmployeeFetch;